<template>
  <div
    v-if="showFloatBtn"
    :class="b()"
  >
    <Highlights
      v-if="lightsData"
      ref="highlights"
      :lights-data="lightsData"
    ></Highlights>
    <LightBulb
      v-if="showGuideMenu"
      :lights-data="lightsData"
    ></LightBulb>
  </div>
</template>

<script>
import Highlights from './Highlights';
import theme from '@zk/theme/lib/variables.scss';
import LightBulb from './lightBulb';
import { getZhGuideInstance } from '@/api/guide';
import store from '@/store';
import { guideUpdateStatus } from '@/api/guide';
import driverMixin from './lightBulb/CloseModuleDriver';
import { mapState } from 'vuex';
export default {
  name:'NewGuide',
  components:{
    Highlights, LightBulb
  },
  mixins: [driverMixin],
  bemNS: theme.bemNS,
  socketEvents: {
    issueAdd(data){
      if (this.account?.userId === data.createByVO?.id) {
        this.finishTask('CREATE_ISSUE');
      }
    },
    'global:Project.detail'(data){
      if (data?.action === 'add' && data?.msgType === 'Project.detail' && data.result?.projectVO?.createBy === this.account?.userId) {
        this.finishTask('CREATE_PERSONAL_PROJECT');
        this.finishTask('CREATE_PROJECT');
      }
    }

  },
  data(){
    return {
      lightsData:null
    };
  },
  computed:{
    ...mapState('user', ['account']),
    allQuestList(){
      return this.lightsData?.userQuestList || [];
    },
    org(){
      return this.$store.state.user.org;
    },
    showFloatBtn() {
      return !this.$route.path.startsWith('/setting/') && !this.$route.path.startsWith('/project/create') && this.$route.meta?.share !== true && !this.$route.meta?.innerShare;
    },
    showGuideMenu() {
      return this.$store.state.guide.guideInfoList?.some(item => item.guideType === 26 && !item.enabled) && this.lightsData?.userQuestList?.length > 0;
    }
  },
  mounted(){
    // 要等token验证成功后才可以初始化，不然会未登录
    this.unwatch = store.watch(state => !!state.user.account?.userId && !!state.user.token, (isLogin) => {
      if (isLogin) {
        setTimeout(this.unwatch, 0);
        if (!store.getters['user/isAnonymous']) {
          this.init();
        }
      }
    }, { immediate: true });
    this.eventBus.$on('close-guide-bulb', this.closeGuide);
  },
  beforeDestroy(){
    if (this.unwatch) {
      this.unwatch();
      this.unwatch = null;
    }
    this.eventBus.$off('close-guide-bulb', this.closeGuide);
  },
  methods:{
    closeGuide(){
      setTimeout(() => {
        this.openCloseDriver();
      }, 1000);
    },
    finishTask(questCode){
      const createIssueTask = this.allQuestList.find(i => i.questCode === questCode);
      if (!createIssueTask) {
        return;
      }
      guideUpdateStatus(createIssueTask.id, 10);
      this.init();
    },
    async init(){
      const lightsData = await getZhGuideInstance();
      this.lightsData = lightsData || {};
      this.$store.commit('guide/SET_GUIDE_TASK', this.lightsData.userQuestList || []);
    }
  }
};
</script>

<style lang="scss" scoped>
   @include b(new-guide){
      margin-right: 13px;
   }
</style>
